import { render, staticRenderFns } from "./BPMNNodeBase.vue?vue&type=template&id=48a25090"
import script from "./BPMNNodeBase.vue?vue&type=script&lang=js"
export * from "./BPMNNodeBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports